<template>
	<article class="notice-page">
		<page-header :title="title" />
		<managing-section>
			<managing-box title="제목">
				<text-counter
					class="notice__subject"
					ref="subject"
					v-model="subject"
					:max-length="50"
					placeholder="입력하세요"
				/>
			</managing-box>
			<managing-box title="노출 상태">
				<RadioList v-model="isDisplay" :radio-list="isDisplayList" />
			</managing-box>
			<managing-box title="내용">
				<text-editor
					class="notice__editor"
					:height="600"
					language="ko_KR"
					:use-block-image="false"
					v-model="content"
				/>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main blue" v-if="modifyMode" @click="postNotice">
				수정
			</button>
			<template v-else>
				<button class="btn-main" @click="initData">초기화</button>
				<button class="btn-main blue" @click="postNotice">등록</button>
			</template>
		</div>
	</article>
</template>
<script>
	import TextEditor from '@/components/TextEditor';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import TextCounter from '@/components/TextCounter.vue';
	import RadioList from '@/components/RadioList';

	export default {
		name: 'Notice',
		components: {
			TextEditor,
			PageHeader,
			ManagingSection,
			ManagingBox,
			TextCounter,
			RadioList,
		},
		data() {
			return {
				modifyMode: false,
				id: null,
				subject: '',
				isDisplayList: [
					{ id: 1, value: '노출' },
					{ id: 0, value: '비노출' },
				],
				isDisplay: 1,
				content: '',
			};
		},
		computed: {
			title() {
				const title = this.$route.query.id
					? '공지사항 수정'
					: '공지사항 등록';
				if (title === '공지사항 수정') this.modifyMode = true;
				document.title = title;
				return title;
			},
		},
		mounted() {
			this.setData();
		},
		methods: {
			async postNotice() {
				if (!this.subject) {
					alert('제목을 입력해 주세요.');
					this.$refs.subject.$refs.input.focus();
					return;
				}
				if (!this.content) {
					alert('내용을 입력해 주세요.');
					return;
				}
				const params = {
					subject: this.subject,
					isDisplay: this.isDisplay,
					content: this.content,
				};
				if (this.id) {
					if (!confirm('수정된 정보로 저장하시겠어요?')) return;
					params.id = this.id;
				}
				await this.$axiosAdmin2.post('/v3/api/notice', params);
				this.$router.go(-1);
			},
			initData() {
				if (!confirm('입력된 정보를 전체 초기화 하시겠어요?')) return;
				this.subject = '';
				this.isDisplay = 1;
				this.content = '';
			},
			async setData() {
				const id = (this.id = this.$route.query.id || null);
				if (!id) return;
				const { data } = await this.$axiosAdmin2.get(
					`/v3/api/notice/${id}`
				);
				this.subject = data.subject;
				this.isDisplay = data.isDisplay;
				this.content = data.content;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.notice__subject {
		width: 100%;
	}

	.notice__editor {
		width: 100%;
	}
</style>
